<script>
export default {

  data() {
    return {
      top: true,
      justChanged: false
    }
  },

  mounted() {
    window.addEventListener("scroll", this.isTop)
  },

  methods: {
    isTop() {
      this.top = window.scrollY === 0
    },
    goToLanding() {
      this.$router.push("/")
    },
  },

  computed: {
    path() {
      let path = this.$route.fullPath;
      let lastIndex = path.lastIndexOf("#");
      return lastIndex === -1 ? path : path.substring(0, lastIndex - 1)

    },
  },

  watch: {
    path: function () {
      this.justChanged = true
      setTimeout(function () {
        this.justChanged = false
      }.bind(this), 100)
    }
  }
}
</script>


<template>
  <nav
      :class="'navbar fixed-top transition-'+(justChanged ? 'changed' : 'base') + ((top && (path==='/' || path==='') ? '' : ' navbg'))">
    <div class="container-fluid">
      <div>
        <img v-on:click="goToLanding" src="/images/logo_mini.webp" :alt="$t('topMenu.altLogo')"
             :class="'logo transition-'+(justChanged ? 'changed' : 'base') + ((top && (path==='/' || path==='') ? ' not_visible' : ' visible'))"/>
        <ul class="nav justify-content-end fixed-top">
          <li class="nav-item">
            <b-link to="/">{{ $t('topMenu.home') }}</b-link>
          </li>
          <li class="nav-item">
            <b-link to="/datacenter">{{ $t('topMenu.datacenter') }}</b-link>
          </li>
          <li class="nav-item">
            <b-link to="/hebergement">{{ $t('topMenu.hosting') }}</b-link>
          </li>
          <li class="nav-item">
            <b-link to="/contact">{{ $t('topMenu.contact') }}</b-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<style scoped>

.not_visible {
  opacity: 0 !important;
}

.visible {
  opacity: 1 !important;
}

.transition-changed {
  transition-duration: 0s !important;
}

.transition-base {
  transition-duration: 2s !important;
}

.navbg {
  background: #012f2d !important;
}


.nav {
  transition-duration: 2s;
  transition-property: background;
  font-family: 'Russo One', sans-serif;
  text-transform: uppercase;
  background: transparent;
}

.logo {
  opacity: 1;
  transition-duration: 2s;
  transition-property: opacity;
}

.nav {
  padding: 20px;
}

a {
  color: #fff !important;
  text-decoration: none;
  padding-top: 15px;
}

a:hover, a:active, .router-link-exact-active {
  color: rgb(51, 224, 145) !important;
}

li {
  padding: 10px 25px 10px 10px;
}


@media screen and (max-width: 530px) {
  .navbar {
    height: 120px;
  }
}

@media screen and (max-width: 1080px) {
  .logo {
    opacity: 0 !important;
  }

  .container-fluid {
    display: block;
  }
}
</style>